import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../components/Admin/Sidebar";
import * as Icon from "react-icons/fa";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ToastContainer } from "react-toastify";
import { CmsContext } from "../../context/CmsContext"; // Import the CMS Context

const Cms = () => {
  const { cmsData, setCmsData, saveCmsData, loading } = useContext(CmsContext); // Use the CMS context
  const [toggleValue, setToggleValue] = useState(false);
  const [isEditable, setIsEditable] = useState(false);

  const [editorData, setEditorData] = useState(cmsData); // Store temporary local state

  useEffect(() => {
    setEditorData(cmsData); // Sync when cmsData updates
  }, [cmsData]);

  const handleInputChange = (field, value) => {
    setEditorData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  // Save CMS Data (using context's saveCmsData function)
  const handleSave = async () => {
    await saveCmsData(editorData); // Save data via context
    setIsEditable(false); // Disable editing after saving
  };

  if (loading) {
    return <div>Loading...</div>; // Handle loading state
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          <Icon.FaArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          />
          <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
            <div className="col-12">
              <div className="mb-4">
                <h5>CMS</h5>
                <h6 className="text-muted">View & manage CMS</h6>
              </div>
              <div className="row bg-light border border-1 p-3 m-1 rounded">
                {/* About Us */}
                <div className="col-12 mb-4">
                  <label className="d-flex align-items-center mb-2">
                    <Icon.FaInfoCircle
                      size={20}
                      className="me-2 text-primary"
                    />
                    About Us
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={cmsData.aboutUs}
                    disabled={!isEditable}
                    onChange={(event, editor) =>
                      handleInputChange("aboutUs", editor.getData())
                    }
                  />
                </div>

                {/* Terms and Conditions */}
                <div className="col-12 mb-4">
                  <label className="d-flex align-items-center mb-2">
                    <Icon.FaFileContract
                      size={20}
                      className="me-2 text-primary"
                    />
                    Terms and Conditions
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={cmsData.terms}
                    disabled={!isEditable}
                    onChange={(event, editor) =>
                      handleInputChange("terms", editor.getData())
                    }
                  />
                </div>

                {/* What We Do */}
                <div className="col-12 mb-4">
                  <label className="d-flex align-items-center mb-2">
                    <Icon.FaTasks size={20} className="me-2 text-primary" />
                    What We Do
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={cmsData.whatWeDo}
                    disabled={!isEditable}
                    onChange={(event, editor) =>
                      handleInputChange("whatWeDo", editor.getData())
                    }
                  />
                </div>

                {/* Privacy Policy */}
                <div className="col-12 mb-4">
                  <label className="d-flex align-items-center mb-2">
                    <Icon.FaLock size={20} className="me-2 text-primary" />
                    Privacy Policy
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={cmsData.privacyPolicy}
                    disabled={!isEditable}
                    onChange={(event, editor) =>
                      handleInputChange("privacyPolicy", editor.getData())
                    }
                  />
                </div>

                {/* Social Media Links */}
                <div className="col-12 mb-4">
                  <label className="d-flex align-items-center mb-2">
                    <Icon.FaShareAlt size={20} className="me-2 text-primary" />
                    Social Media Links
                  </label>
                  <div className="ms-3 mt-4">
                    {/* Facebook */}
                    <div className="mb-3">
                      <label className="d-flex align-items-center mb-3">
                        <Icon.FaFacebook
                          size={20}
                          color="#4267B2"
                          className="me-2"
                        />
                        Facebook Link
                      </label>
                      <input
                        type="url"
                        className="form-control"
                        placeholder="Paste your Facebook link"
                        value={editorData.facebookLink}
                        onChange={(e) =>
                          handleInputChange("facebookLink", e.target.value)
                        }
                        disabled={!isEditable}
                      />
                    </div>

                    {/* Instagram */}
                    <div className="mb-3">
                      <label className="d-flex align-items-center mb-3">
                        <Icon.FaInstagram
                          size={20}
                          color="#C13584"
                          className="me-2"
                        />
                        Instagram Link
                      </label>
                      <input
                        type="url"
                        className="form-control"
                        placeholder="Paste your Instagram link"
                        value={editorData.instagramLink}
                        onChange={(e) =>
                          handleInputChange("instagramLink", e.target.value)
                        }
                        disabled={!isEditable}
                      />
                    </div>

                    {/* YouTube */}
                    <div className="mb-3">
                      <label className="d-flex align-items-center mb-3">
                        <Icon.FaYoutube
                          size={20}
                          color="#FF0000"
                          className="me-2"
                        />
                        YouTube Link
                      </label>
                      <input
                        type="url"
                        className="form-control"
                        placeholder="Paste your YouTube link"
                        value={editorData.youtubeLink}
                        onChange={(e) =>
                          handleInputChange("youtubeLink", e.target.value)
                        }
                        disabled={!isEditable}
                      />
                    </div>
                  </div>
                </div>
                {/* contact us */}
                <div className="col-12 mb-4">
                  <label className="d-flex align-items-center mb-2">
                    <Icon.FaPhoneAlt size={20} className="me-2 text-primary" />
                    Contact Us
                  </label>
                  <div className="ms-3 mt-4">
                    {/* mobile number */}
                    <div className="mb-3">
                      <label className="d-flex align-items-center mb-3">
                        <Icon.FaMobileAlt
                          size={20}
                          color="#FF0000"
                          className="me-2"
                        />
                        Mobile Number
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Enter Phone Number"
                        value={editorData.phoneNumber}
                        onChange={(e) =>
                          handleInputChange("phoneNumber", e.target.value)
                        }
                        disabled={!isEditable}
                      />
                    </div>
                  </div>
                </div>
                {/* Edit and Save Buttons */}
                <div className="col-12 text-end">
                  {isEditable ? (
                    <button className="btn btn-success" onClick={handleSave}>
                      Save CMS Data
                    </button>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={() => setIsEditable(true)}
                    >
                      Edit CMS Data
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer theme="dark" autoClose={2000} />
      </div>
    </div>
  );
};

export default Cms;
